module.exports = __webpack_public_path__ + "img/ring_y_e_null_0@2x.1f0f6edc.png";